import "./CreativeMap.scss";
import { Page } from "../Components";
import { RouteComponentProps, Router } from "@reach/router";
import { useTabbedNav } from "../utils/hooks/useNav";
import * as R from "ramda";
import ConceptsAttributes from "./Tabs/ConceptsAttributes";
import CreativeList from "./Tabs/CreativeList";
import React from "react";

const enum PageTab {
  CREATIVE_LIST = "creative-list",
  CONCEPTS_ATTRIBUTES = "concepts-attributes",
}

const NAVS = [
  { label: "Creative List", key: PageTab.CREATIVE_LIST },
  { label: "Concepts and Attributes", key: PageTab.CONCEPTS_ATTRIBUTES },
];

export default React.memo(({ navigate }: RouteComponentProps) => {
  const { tab, goToTab } = useTabbedNav({
    baseURL: "creative-map-v2",
    defaultKey: PageTab.CREATIVE_LIST,
    navigate,
    navs: R.map(R.prop("key"), NAVS),
  });

  return (
    <Page
      app2Redesign
      navs={NAVS}
      onNav={goToTab}
      pageType="Creative Map"
      selectedNav={tab}
      title="Creative Map"
    >
      <Router className="fullPageRouter">
        <CreativeList path={PageTab.CREATIVE_LIST} />
        <ConceptsAttributes path={PageTab.CONCEPTS_ATTRIBUTES} />
      </Router>
    </Page>
  );
});
